module.exports = require('make-cancellable-promise')
